import { render } from "./instrument.vue?vue&type=template&id=3e7c7f90&scoped=true"
import script from "./instrument.vue?vue&type=script&lang=js"
export * from "./instrument.vue?vue&type=script&lang=js"

import "./instrument.vue?vue&type=style&index=0&id=3e7c7f90&scoped=true&lang=css"

import exportComponent from "D:\\code\\vue\\gaoxinTech\\gaoxin_tech1\\gaoxintech\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e7c7f90"]])

export default __exports__